import React, { useEffect } from 'react'
import { Button, Spin } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../i18n'
import Actions from '../../../actions'
import './InvalidIp.css'

const InvalidIp = () => {
  const { isValidatingIpLoading, isInvalidIpRecieved } = useSelector(
    state => state.auth
  )

  const dispatch = useDispatch()

  const reloadPage = () => {
    dispatch(Actions.createAction(Actions.IS_IP_CHANGED_ON_RELOAD))
  }

  const renderUi = () => {
    if (isValidatingIpLoading) {
      return (
        <div className="invalid-ip-container">
          <Spin size="large" />
        </div>
      )
    }
    return (
      <div className="invalid-ip-container">
        <div className="no-service-description-container">
          <div className="no-service-location-text main-title">
            {$t('pages.getStarted.invalidIp.noServiceText')}
          </div>
          <div className="renew-ip-instructions-text">
            {$t('pages.getStarted.invalidIp.renewIpInstructionsText')}
          </div>
          <a
            href={
              'https://frontier.com/helpcenter/categories/internet/troubleshooting/release-renew-ip-address'
            }
            rel="noreferrer"
            target="_blank"
            className="renew-you-ip-instruction-link"
          >
            {$t('pages.getStarted.invalidIp.renewYourIpOnWindowsOrMac')}
          </a>
        </div>
        <div className="reload-page-button-container">
          <Button onClick={reloadPage} className="reload-page-button">
            {$t('pages.getStarted.invalidIp.reloadThePage')}
          </Button>
        </div>
        <div className="cannot-provide-service-description">
          {$t('pages.getStarted.invalidIp.cannotProvideServiceDescription')}
        </div>
      </div>
    )
  }

  return renderUi()
}

export default InvalidIp
